import React from 'react';
import WebPage from 'components/WebPage/WebPage';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';

const DynamicWebComponent = () => {
  const urlSelector = useSelector(selectors.app.getProgramUrl);

  return <WebPage url={`${urlSelector}`} />;
};

export default DynamicWebComponent;
